import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentVarsService } from '@go-modules/services/environment-vars/environment-vars.service';
import { ENVIRONMENTS } from '@go-modules/services/environment-vars/environments';
import { clientSettings } from 'go-modules/models/common/client.settings';

export const UNIFIED_LOGIN_SCRIPT_ID = 'unified-login-app-switcher-script';

@Injectable({
	providedIn: 'root'
})
export class UnifiedLoginScriptService {
	private scriptLoaded = false;

	constructor (
		@Inject(DOCUMENT) private document: Document,
		private environmentVarsService: EnvironmentVarsService
	) {}

	public load (): void {
		if (this.environmentVarsService.environmentIs(ENVIRONMENTS.LTI) || this.scriptLoaded) {
			return;
		}

		const existingScript = this.document.getElementById(UNIFIED_LOGIN_SCRIPT_ID);
		if (existingScript != null) {
			this.scriptLoaded = true;
			return;
		}

		const script = this.document.createElement('script');
		script.id = UNIFIED_LOGIN_SCRIPT_ID;
		script.src = clientSettings.UnifiedLoginScriptUrl;
		script.async = true;
		this.document.head.appendChild(script);
		this.scriptLoaded = true;
	}
}
